// App: оборачивает роутер провайдерами (auth + tenant).
// QueryClientProvider живёт уровнем выше (в main.tsx), чтобы тесты могли передать свой QueryClient.

import { BrowserRouter, useRoutes } from 'react-router-dom';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AuthProvider } from '@/lib/auth-context';
import { RepeatGuardProvider } from '@/lib/repeat-guard';
import { TenantProvider } from '@/lib/tenant-context';
import { useTrackPageViews } from '@/lib/use-track-page-views';
import { routes } from '@/routes';

function AppRoutes(): JSX.Element | null {
  // Телеметрия просмотров экранов (docs/service/37) — внутри роутера.
  useTrackPageViews();
  return useRoutes(routes);
}

export interface AppProps {
  // Для тестов: позволяем использовать MemoryRouter, передав router сверху.
  router?: typeof BrowserRouter;
}

export function App({ router: Router = BrowserRouter }: AppProps): JSX.Element {
  return (
    <Router>
      <TenantProvider>
        <AuthProvider>
          <RepeatGuardProvider>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </RepeatGuardProvider>
        </AuthProvider>
      </TenantProvider>
    </Router>
  );
}
